import React, { FunctionComponent } from 'react';
import { StyleProp, StyleSheet, TouchableOpacity, ViewStyle } from 'react-native';
import { Icon } from '../../components';
import Theme from '../../theme';
import { defaultScale } from '../../utils';

interface IProps {
  onClose: () => void;
  containerStyle?: StyleProp<ViewStyle>;
}

export const HeaderWithCloseButton: FunctionComponent<IProps> = ({ onClose, containerStyle }) => {
  const hitSlopValue = defaultScale(20);

  const hitSlop = {
    bottom: hitSlopValue,
    top: hitSlopValue,
    left: hitSlopValue,
    right: hitSlopValue,
  };

  return (
    <TouchableOpacity
      hitSlop={hitSlop}
      onPress={onClose}
      style={[styles.header, containerStyle]}
    >
      <Icon
        name={'md-close'}
        color={Theme.GREY}
        size={defaultScale(30)}
      />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
});
